import React from "react";

const TICKER_TEXT = "ExD Digital Careers";
const TICKER_ITEMS = Array.from({ length: 8 });

const Section2 = () => {
  return (
    <section className="careers-section-2">
      <div className="careers-marquee">
        <div className="marquee-track">
          {[0, 1].map((dup) => (
            <div className="marquee-group" key={dup} aria-hidden={dup === 1}>
              {TICKER_ITEMS.map((_, i) => (
                <span className="marquee-item" key={i}>
                  {TICKER_TEXT}
                  <span className="dash">—</span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Section2;
